/**
 * The dock's suggested questions, resolved from the screen the reader is on.
 *
 * PLACEHOLDERS. One pair per module and per detail screen, to be replaced with the
 * real set; the wording lives in `dock.prompts.*` in `app.json`, so replacing them
 * is a copy change, and adding a screen is one entry here.
 *
 * Ids, not sentences — paths under `dock.prompts`.
 */

const BY_MODULE = {
  anomalies: { list: ['anomalies.listAll', 'anomalies.critical'], detail: ['anomalies.whatHappened', 'anomalies.readings', 'anomalies.summariseRca'] },
  work_orders: { list: ['workOrders.overdue', 'workOrders.unassigned'] },
  logbook: { list: ['logbook.recent', 'logbook.safety'], detail: ['logbook.summarise', 'logbook.related'] },
  shift_handovers: { list: ['shiftHandovers.latest', 'shiftHandovers.open'], detail: ['shiftHandovers.summarise', 'shiftHandovers.followUp'] },
  sensors: { list: ['sensors.drifting', 'sensors.silent'], detail: ['sensors.readings', 'sensors.anomalies'] },
  documents: { list: ['documents.find', 'documents.recent'] },
  assets: { list: ['assets.worst', 'assets.health'] },
  shifts: { list: ['shifts.current', 'shifts.coverage'] },
}

/** Everywhere without a module of its own. */
const GENERAL = ['general.workOrder', 'general.similar', 'general.drifting']

/**
 * @param {{module: string|null, recordId: string|null}} context `pageContextFor(pathname)`
 * @returns {string[]} ids under `dock.prompts`, in the order they are offered
 */
export function dockPromptsFor({ module, recordId } = {}) {
  const set = module ? BY_MODULE[module] : null
  if (!set) return GENERAL
  return (recordId ? set.detail : null) ?? set.list
}
